
import { useState } from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'أحمد محمد العمري',
      location: 'الرياض',
      date: 'ديسمبر 2024',
      rating: 5,
      text: 'تجربة رائعة ومميزة! السائق كان محترفاً جداً ووصلنا إلى الفندق في مكة بكل راحة وأمان. السيارة نظيفة وفاخرة والخدمة ممتازة. أنصح الجميع بالتعامل مع فخامة الرفاهية للتوصيل.',
      image: 'https://public.readdy.ai/ai/img_res/c83789d0802b2cf3fef649c3c82bcdc4.jpg',
    },
    {
      id: 2,
      name: 'فاطمة عبدالله السالم',
      location: 'جدة',
      date: 'نوفمبر 2024',
      rating: 5,
      text: 'خدمة احترافية من البداية للنهاية. تم استقبالنا في المطار بلوحة تحمل اسمنا، والسائق ساعدنا في حمل الأمتعة. الرحلة كانت مريحة جداً وشعرنا بالأمان طوال الطريق. شكراً لكم على هذه الخدمة المتميزة.',
      image: 'https://readdy.ai/api/search-image?query=elegant%20middle%20eastern%20woman%20wearing%20hijab%20and%20abaya%2C%20warm%20smile%2C%20professional%20portrait%20photography%2C%20modern%20studio%20setting%2C%20confident%20and%20friendly%20expression%2C%20natural%20lighting%2C%20authentic%20saudi%20arabian%20woman&width=200&height=200&seq=client-002&orientation=squarish',
    },
    {
      id: 3,
      name: 'عبدالرحمن خالد الشمري',
      location: 'الدمام',
      date: 'أكتوبر 2024',
      rating: 5,
      text: 'أفضل خدمة توصيل جربتها في حياتي! السيارة كانت فخمة ونظيفة، والسائق كان ودوداً ويعرف الطرق جيداً. وصلنا في الوقت المحدد بالضبط. سأستخدم خدماتهم في كل مرة أزور فيها مكة المكرمة.',
      image: 'https://readdy.ai/api/search-image?query=young%20middle%20eastern%20man%20wearing%20traditional%20saudi%20thobe%20and%20ghutra%2C%20friendly%20smile%2C%20professional%20portrait%2C%20modern%20photography%2C%20clean%20studio%20background%2C%20confident%20expression%2C%20warm%20natural%20lighting&width=200&height=200&seq=client-003&orientation=squarish',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="text-gold text-4xl font-serif">"</span>
            <h3 className="text-luxury-black font-almarai font-bold text-4xl lg:text-5xl">
              آراء <span className="text-gold">عملائنا</span>
            </h3>
            <span className="text-gold text-4xl font-serif">"</span>
          </div>
          <div className="w-20 h-1 bg-gold mx-auto"></div>
        </div>

        {/* Main Testimonial Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-luxury-cream to-white rounded-3xl p-12 shadow-xl relative">
            {/* Rating Badge */}
            <div className="absolute top-8 left-8 bg-luxury-black text-white px-5 py-2 rounded-full flex items-center gap-2">
              <i className="ri-star-fill text-gold text-lg"></i>
              <span className="font-cairo font-bold">{current.rating}.0</span>
            </div>

            {/* Quote Marks */}
            <div className="text-gold text-7xl font-serif leading-none mb-6 text-right">"</div>

            {/* Testimonial Text */}
            <p className="text-luxury-gray font-cairo text-xl lg:text-2xl leading-relaxed text-right mb-8 px-4">
              {current.text}
            </p>

            <div className="text-gold text-7xl font-serif leading-none text-left -mt-4">"</div>

            {/* Client Info */}
            <div className="flex items-center gap-6 mt-8 pt-8 border-t border-luxury-gray/20">
              <img
                src={current.image}
                alt={current.name}
                className="w-20 h-20 rounded-full object-cover border-4 border-gold/30"
              />
              <div className="text-right flex-1">
                <h4 className="font-cairo font-bold text-xl text-luxury-black mb-1">
                  {current.name}
                </h4>
                <p className="font-cairo text-luxury-gray">
                  {current.location} • {current.date}
                </p>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="w-14 h-14 flex items-center justify-center bg-white border-2 border-luxury-gray/30 hover:border-gold rounded-lg transition-all duration-300 hover:scale-110 group cursor-pointer"
            >
              <i className="ri-arrow-right-line text-luxury-black group-hover:text-gold text-xl"></i>
            </button>
            <button
              onClick={nextTestimonial}
              className="w-14 h-14 flex items-center justify-center bg-luxury-black hover:bg-gold rounded-lg transition-all duration-300 hover:scale-110 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-white text-xl"></i>
            </button>
          </div>

          {/* Dots Indicator */}
          <div className="flex items-center justify-center gap-2 mt-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex ? 'w-8 bg-gold' : 'w-2 bg-luxury-gray/30'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
